import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="border-y border-primary/15 bg-surface/40 py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-73" data-mp="4vs0rz0u8fre">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-74" data-mp="9t1pfcgekne6">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-3xl border-2 border-primary/40 bg-background/60 p-8 shadow-2xl shadow-black/40 backdrop-blur-md sm:p-12" data-id="element-75" data-mp="euh8iyz0sjtx">
          <span className="inline-flex rounded-full border border-primary/50 bg-surface/60 p-4 text-primary" data-id="element-76" data-mp="xjnuqvz0vtkh">
            <ShieldCheckIcon className="h-10 w-10 drop-shadow-glow" aria-hidden="true" data-id="element-77" data-mp="12jjx6qs2ncxx" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-balance text-3xl font-extrabold uppercase tracking-tight text-foreground sm:text-4xl" data-id="element-78" data-mp="17hbslurxdh6v">
            Garanzia di soddisfazione <span className="text-accent" data-id="element-79" data-mp="20su412tqqnr0">di 7 giorni</span>
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-muted" data-id="element-80" data-mp="20ux3sekp3v8x">
            Se entro 7 giorni il materiale non fa per te,{' '}
            <span className="font-extrabold text-accent" data-id="element-81" data-mp="1rsff7thkiqir">ti rimborsiamo. Senza domande.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}